// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as AuthActions } from '../../auth/duck';
import { actions as NotificationsActions } from '../notifications/duck';
import { actions as OrderActions } from '../../order/duck';
import { actions as ShoppingCartActions } from '../../shopping-cart/duck';
import Navbar from '../components/Navbar';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    isAuthing: state.auth.isAuthing,
    locale: state.locale,
    localValues: state.localValues,
    notificationsState: state.navbar.notifications,
    router: state.router,
    postCartItemSuccess: state.shoppingCart.postCartItemSuccess,
    shoppingCart: state.shoppingCart.shoppingCart,
    virtualShoppingCart: state.shoppingCart.virtualShoppingCart,
    virtualShoppingCartInitialized: state.shoppingCart.virtualShoppingCartInitialized,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...AuthActions, ...NotificationsActions, ...OrderActions,
    ...ShoppingCartActions,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/modules/navbar/containers/NavbarContainer.js